import { render, staticRenderFns } from "./FileInputLimiting.vue?vue&type=template&id=08edf7b4&"
import script from "./FileInputLimiting.vue?vue&type=script&lang=js&"
export * from "./FileInputLimiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports